module.exports = __webpack_public_path__ + "static/media/eco-ecology-nature-19-svgrepo-com.a24cd25c.svg";